import Vue from 'vue';
import Vuex from 'vuex';

import app from './app';

import activities from './modules/activities';
import afstereo from './modules/afstereo';
import alerts from './modules/alerts';
import analytics from './modules/analytics';
import auth from './modules/auth';
import campaign from './modules/campaign';
import channel from './modules/channel';
import company from './modules/company';
import contacts from './modules/contacts';
import filebox from './modules/filebox';
import interaction from './modules/interaction';
import modals from './modules/modals';
import plugin from './modules/plugin';
import profile from './modules/profile';
import rules from './modules/rules';
import social from './modules/social';
import stationactivity from './modules/stationactivity';
import survey from './modules/survey';
import telegram from './modules/telegram';
import timeslots from './modules/timeslots';
import toast from './modules/toast';
import tokens from './modules/tokens';
import user from './modules/user';
import blacklist from './modules/blacklist';
import whatsapp from './modules/whatsapp';
import publishing from './modules/publishing';
import surveybuilder from './modules/surveybuilder';
import privacy from './modules/privacy';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  ...app,
  modules: {
    activities,
    afstereo,
    alerts,
    analytics,
    auth,
    campaign,
    channel,
    company,
    contacts,
    filebox,
    interaction,
    modals,
    plugin,
    profile,
    rules,
    social,
    stationactivity,
    survey,
    telegram,
    timeslots,
    toast,
    tokens,
    user,
    blacklist,
    whatsapp,
    publishing,
    surveybuilder,
    privacy,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js